import {
  Component,
  ElementRef,
  HostListener,
  inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { SidebarService } from '../../@core/services/signals/sidebar.services';
import { RouterModule } from '@angular/router';
import { AppFullRoutes } from '../../@core/enum/appRoutes';
import { AuthService } from '../../modules/authentication/auth.service';
import { Store } from '@ngrx/store';
import { getCurrentUser, getUserRole } from '../../@core/store/auth-state/auth.selectors';


@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [CommonModule, RouterModule,],
  templateUrl: './navbar.component.html',
  styleUrl: '../layouts.component.scss',
})
export class NavbarComponent implements OnInit {
  profileImage: string | null = null;
  userName: string = 'Ibrahim Jamiu';
  isMobileView = false;
  isSmallMobileView = false;
  isSidebarOpen$!: Observable<boolean>;
  homIsDropdownOpen: boolean = false;
  isDropdownOpen: boolean = false;
  @ViewChild('userDropdown') userDropdown!: ElementRef;
  @ViewChild('dropdownWrapper') dropdownWrapper!: ElementRef;
  userRole: string | null = null;
  Notification = AppFullRoutes.FULL_NOTIFICATION;
  settings = AppFullRoutes.FULL_SETTINGS;
  selectedValue: string | null = null;
  defaultValue = 'Mount ola omo HMO';
 userRole$!: Observable<string | null>;
  sidebarService = inject(SidebarService);
organizationName: string | null = null;

 // ------- CLEAN COLOR PALETTE -------
  private readonly colorPalette = [
    '#F94847', 
    '#635BFF', 
    '#2EA843', 
    '#F97B26', 
    '#CD079B', 
    '#0A4EF5', 
    '#044499', 
    '#123300',
    '#D56139',
    '#FD13BD',
    '#5D1D1D',
    '#9747FF'
  ];
  constructor(private readonly authService: AuthService, private readonly store: Store) {}
 

  ngOnInit(): void {
     this.store.select(getCurrentUser).subscribe(user => {
       if (user?.name) {
          this.userName = `${user.name}`;
       } else if (user?.given_name && user?.family_name) {
        this.userName = `${user.given_name} ${user.family_name}`;
       }
        });

         this.store.select(getCurrentUser).subscribe(user => {
    // -----------------------------
    // User full name
    // -----------------------------
    if (user?.name) {
      this.userName = user.name;
    } else if (user?.given_name && user?.family_name) {
      this.userName = `${user.given_name} ${user.family_name}`;
    }

    // -----------------------------
    // Organization name (NEW)
    // -----------------------------
    const primaryRole = user?.roles?.[0];
    this.organizationName =
      primaryRole?.organization_name ?? null;
  });

     const savedValue = localStorage.getItem('selectedOption');
    this.checkViewportWidth();
this.userRole$ = this.store.select(getUserRole);

this.userRole$.subscribe(role => {
  this.userRole = role;
})
   
  if (savedValue) {
      this.selectedValue = savedValue;
    } else {
      this.selectedValue = this.defaultValue;
      localStorage.setItem('selectedOption', this.defaultValue);
    }
  }
 // =============== SMART COLOR FUNCTIONS ===============


  // Pick stable color from palette based on name
get initialsBgColor(): string {
  if (!this.userName) return this.colorPalette[0];

  let hash = 0;
  for (let i = 0; i < this.userName.length; i++) {
    hash = this.userName.charCodeAt(i) + ((hash << 5) - hash);
  }

  const index = Math.abs(hash) % this.colorPalette.length;
  return this.colorPalette[index];
}

  get initialsTextColor(): string {
  return '#FFFFFF';
}



  @HostListener('window:resize')
  onResize(): void {
    this.checkViewportWidth();
  }
  options = [
    { label: 'Hygeia HMO', value: 'Hygeia HMO' },
    { label: 'AXA Mansard', value: 'AXA Mansard' },
    { label: 'Reliance HMO', value: 'Reliance HMO' },
    { label: 'Avon HMO', value: 'Avon HMO' },
    { label: 'MetroHealth HMO', value: 'MetroHealth HMO' },
    { label: 'Total Health Trust', value: 'Total Health Trust' },
  ];

  checkViewportWidth(): void {
    this.isMobileView = window.innerWidth <= 940; // Set mobile view flag
    this.isSmallMobileView = window.innerWidth <= 500;
  }
getInitials(name?: string): string {
  if (!name) return '';

  return name
    .trim()
    .split(/\s+/) // handles multiple spaces automatically
    .map(part => part.charAt(0).toUpperCase())
    .slice(0, 2)
    .join('');
}
  // getInitials(name: string): string {
  //   return name
  //     ? name
  //         .split(' ')
  //         .map((part) => part[0].toUpperCase())
  //         .slice(0, 2)
  //         .join('')
  //     : '';
  // }
  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }
  toggleHMODropdown() {
    this.homIsDropdownOpen = !this.homIsDropdownOpen;
  }

  logOut() {
    this.isDropdownOpen = false;
    this.authService.logout();
  }
  selectOption(value: string) {
    this.selectedValue = value;
    localStorage.setItem('selectedHmo', value);
    this.homIsDropdownOpen = false; //    closes dropdown
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const dropdown = this.userDropdown?.nativeElement;

    if (dropdown && !dropdown.contains(target) && !target.closest('.profile')) {
      this.isDropdownOpen = false;
      
    }
  }

get displayRole(): string {

  if (!this.userRole) return '';

  switch (this.userRole.toLowerCase()) {
    case 'superadmin':
      return 'Super Admin';

    case 'hmo':
      return 'Admin';
    case 'nhia':
      return 'Admin';

    case 'insuree':
      return 'PolicyHolder';

    default:
      return this.userRole;
  }

}
 
}
